import { pricebookQuery } from '@/utilities/megalithQueries'

/**
 * Factory for all pricebook related queries and overarching query keys.
 * TODO: Once the QT is transitioned to TS, use the `queryOptions` helper for extra type safety and a better DX, see: https://tkdodo.eu/blog/the-query-options-api#query-factories.
 */
export const pricebookQueryFactory = {
  // Base key for all pricebook related queries. These can be used for less granular actions, such as invalidating all MVE pricebook queries.
  allSubKey: () => ['pricing'],
  megaportSubKey: () => [...pricebookQueryFactory.allSubKey(), 'megaport'],
  mcrSubKey: () => [...pricebookQueryFactory.allSubKey(), 'mcr'],
  mveSubKey: () => [...pricebookQueryFactory.allSubKey(), 'mve'],
  vxcSubKey: () => [...pricebookQueryFactory.allSubKey(), 'vxc'],
  ixSubKey: () => [...pricebookQueryFactory.allSubKey(), 'ix'],
  vxcTermsSubKey: () => [...pricebookQueryFactory.allSubKey(), 'vxcTerms'],
  // These generate the base query options for each pricebook related query.
  megaport: (payload, config) => pricebookQuery('megaport', payload, config),
  mcr: (payload, config) => pricebookQuery('mcr', payload, config),
  mve: (payload, config) => pricebookQuery('mve', payload, config),
  vxc: (payload, config) => pricebookQuery('vxc', payload, config),
  ix: (payload, config) => pricebookQuery('ix', payload, config),
  vxcTerms: (payload, config) => pricebookQuery('vxcTerms', payload, config),
}
